import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

import { Button, H6, ProgressBar, FormGroup, InputGroup, NumericInput } from '@blueprintjs/core';
import { Paper } from '@material-ui/core';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';
// import Cookies from 'js-cookie';
// import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants';
import MaterialTable from 'material-table';
import { CsvBuilder } from "filefy";
// import { rounded } from '../../../utils.js'

//import './DocStats.css';

//import { min } from 'lodash';

class GlobalCount extends React.PureComponent {

  state = {
    waitingForCount:false,
    countType:"repeatedSents",
    tableRows:[],
    columns:[],
    fields:[],
    ngramMaxLength:10,
    ngramMinLength:3,
    minFreq:3,
    sentMaxLength:0,
    feas:"w",
    ngramDeduplicateRatio:0.6
  }

  // run get_global_count which returns a json table with the fields in the first row and the data after
  fetchCountResult = () => {
    const endpoint = process.env.REACT_APP_API_BASE +'/get_global_count.ajax.php';
    //const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
    this.setState({ waitingForCount:true });
    fetch(
        endpoint , {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ 
          countType:this.state.countType, 
          session_id:this.props.session_id,
          minFreq:this.state.minFreq,
          sentMaxLength:this.state.sentMaxLength,
          feas:this.state.feas,
          ngramMaxLength:this.state.ngramMaxLength,
          ngramMinLength:this.state.ngramMinLength,
          ngramDeduplicateRatio:this.state.ngramDeduplicateRatio,
        }),
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        this.setState({ waitingForCount:false }); 
        return;
      }
      res.json().then((data) => {
        const fields=data.shift();
        const columns=[];
        // compute cols
        for (var field of fields) {
          columns.push(
            { 
              title: this.props.t(field), 
              field: field, 
              //render: rowData => Intl.NumberFormat(langFormat, { useGrouping: true }).format(rowData[field]),
              cellStyle: {
                textAlign:'left',
            },
            headerStyle:{
              textAlign:'left'
            },
            }
          )
        }
        // compute rows
        const tableRows=[];
        for (var line of data) {
          const row={};
          for (var i in line) {
            row[fields[i]]=line[i];
          }
          tableRows.push(row);
        }
        // record the result in the state
        this.setState({ tableRows, columns, fields, waitingForCount:false }); 
      });
    })
  }


  render() {
    const { t } = this.props;
    
    const values= ['repeatedSents','ngrams'];
    const options= values.map( v=> t(v));
  
    return(
      <>
          <Paper className="margin-bottom-1-5-rem padding-1-rem">

            <EnhancedSingleSelect
              label={t('countType')}
              name='countType'  // name is also used to make the input's `id`
              hasDefault={true}
              hasSelectableDefault={false}
              options={options}
              value={t(this.state.countType)}
              onChange={(e)=>{ 
                e.preventDefault(); 
                const { value } = e.target;
                this.setState({ countType: values[options.indexOf(value)] });
              }}
            />

            <H6>{t('parameters')}</H6>

            <FormGroup label={t('features')} inline={true}>
              <InputGroup
                type="text" 
                value={this.state.feas}
                onChange={(e) => { 
                  this.setState({feas:e.target.value});
                }}
              /> 
            </FormGroup>
            <FormGroup label={t('minFreq')} inline={true}>
              <NumericInput
                buttonPosition={null}
                value={this.state.minFreq}
                onValueChange={(newValue) => { 
                  this.setState({minFreq:newValue});
                }}
              /> 
            </FormGroup>

            { this.state.countType==="repeatedSents" &&

            <FormGroup label={t('sentMaxLength')} inline={true} helperText={t('zeroIfNoLimit')}>
              <NumericInput
                buttonPosition={null}
                value={this.state.sentMaxLength}
                onValueChange={(newValue) => { 
                  this.setState({sentMaxLength:newValue});
                }}
              /> 
            </FormGroup>
            }

            { this.state.countType==="ngrams" &&
              <>

                <FormGroup label={t('minLength')} inline={true} >
                  <NumericInput

                    buttonPosition={null}
                    value={this.state.ngramMinLength}
                    onValueChange={(newValue) => { 
                      this.setState({ngramMinLength:newValue});
                    }}
                  /> 
                </FormGroup>

                <FormGroup label={t('maxLength')} inline={true}>
                  <NumericInput
                    buttonPosition={null}
                    value={this.state.ngramMaxLength}
                    onValueChange={(newValue) => { 
                      this.setState({ngramMaxLength:newValue});
                    }}
                  /> 
                </FormGroup>

                <FormGroup label={t('deduplicateRatio')} inline={true}>
                  <NumericInput
                    buttonPosition={null}
                    value={this.state.ngramDeduplicateRatio}
                    onValueChange={(newValue) => { 
                      this.setState({ngramDeduplicateRatio:newValue});
                    }}
                  /> 
                </FormGroup>
              </>

            }

            <Button text={t('count')} onClick={this.fetchCountResult}  className='bp3-intent-primary'/>
        
            {  this.state.waitingForCount && 
              <div>
                <br/>
                <br/>
                < ProgressBar />
              </div> 
            }

            { ! this.state.waitingForCount && 
              <>
                <br/>
                { this.state.tableRows.length>0 &&
                  <>  
                    <br/>
                    <br/>
                   
                    <MaterialTable
                        title={t(this.state.countType)}
                        columns={this.state.columns}
                        data={this.state.tableRows}
                        options={{
                          filtering: true,
                          search: true,
                          sorting: true,
                          exportButton: true,
                          exportAllData: true,
                          paging: false,
                          padding: 'dense',
                        }}
                        components={{
                          exportCsv: (columns, data) => {
                            const fileName = "global_count";
                            const builder = new CsvBuilder(
                                fileName + ".csv"
                            );
                            builder
                                .setColumns( Object.keys(this.state.fields).sort() )
                                .setDelimeter(this.props.csvDelimiter).addRows(
                                  data.map((rowData) => this.state.fields.map(key=>rowData.key))
                                )
                                .exportFile();
                          },
                          Container: props => (
                            <Paper
                              {...props}
                              elevation={0}
                            />
                          ),
                        }}
                    />
                   
                  </>
                }
 
            </> // end of table component
          }
        </Paper>
    
      </>
    );
  }

}

GlobalCount.propTypes = {
  session_id: PropTypes.string,
  csvDelimiter: PropTypes.string,
};

export default withTranslation()(GlobalCount  );
